import React from "react";
import CategoriesIcon from "../../../assets/images/categoriesLogo.svg";

const CustomDrawing = ({ ref, numLines }) => {
  // Constants
  const curveWidth = 70; // Fixed width for the curved ends
  const containerWidth = 600; // Width of the container
  const verticalSpacing = 70; // Spacing between vertical lines

  // Calculate total width required for the lines and spaces
  const totalHorizontalLength = (numLines - 1) * verticalSpacing; // Total width covered by gaps between lines
  const startX = (containerWidth - totalHorizontalLength) / 2; // Ensure equal spacing from edges
  const endX = startX + totalHorizontalLength;

  // Function to calculate positions for vertical lines
  const getVerticalLinePositions = () => {
    const positions = [];
    for (let i = 0; i < numLines; i++) {
      positions.push(startX + i * verticalSpacing);
    }
    return positions;
  };

  // Handle edge cases for numLines
  const verticalLinePositions = numLines > 0 ? getVerticalLinePositions() : [];
  const isSingleLine = numLines < 0;

  return (
    <div className="leap-flex leap-justify-center leap-w-full leap-h-auto">
      <svg
        width="600"
        height="200"
        viewBox={`${startX - curveWidth - 20} 0 ${totalHorizontalLength + curveWidth * 2 + 40} 200`}
        xmlns="http://www.w3.org/2000/svg"
        className="leap-w-full leap-h-auto"
      >
        {/* Horizontal Line with Curved Ends */}
        {numLines > -1 && (
          <path
            ref={ref}
            d={
              numLines !== 0
                ? `M${startX} 20 H${endX} Q${endX + curveWidth} 20, ${endX + curveWidth} 70 M${startX} 20 Q${startX - curveWidth} 20, ${startX - curveWidth} 70`
                : `M${containerWidth / 2} 20  Q${containerWidth / 2 - curveWidth} 20, ${containerWidth / 2 - curveWidth} 70  M${containerWidth / 2} 20  Q${containerWidth / 2 + curveWidth} 20, ${containerWidth / 2 + curveWidth} 70`
            }
            fill="none"
            stroke="url(#gradient)"
            strokeWidth="1"
            strokeLinecap="round"
          />
        )}

        {/* Vertical Lines */}
        {numLines > 0 &&
          verticalLinePositions?.map((x, index) => (
            <rect
              key={index}
              x={x - 1.5} /* Center align the rect */
              y="20"
              width="1" /* Thickness of the vertical line */
              height="50" /* Length of the vertical line */
              fill="url(#gradient)"
            />
          ))}

        {/* Single Vertical Line for numLines < 0 */}
        {isSingleLine && (
          <rect
            x={containerWidth / 2 - 1.5} /* Center align the rect */
            y="20"
            width="1" /* Thickness of the vertical line */
            height="50" /* Length of the vertical line */
            fill="url(#gradient)"
          />
        )}

        {/* Categories Icon */}
        <image
          href={CategoriesIcon}
          x={(startX + endX) / 2 - 20} /* Center the image */
          y="0"
          width="40"
          height="40"
        />

        {/* Gradient Definitions */}
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#EB3DF7" />
            <stop offset="50%" stopColor="#3B29AB" />
            <stop offset="100%" stopColor="#73FAFD" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default CustomDrawing;
